/**
 * DetailEventTitle component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail event title.
 */
const DetailEventTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${56 * Screen.widthRatio}px;
  letter-spacing: ${-0.25 * Screen.widthRatio}px;
  line-height: ${64 * Screen.widthRatio}px;
  margin-bottom: ${24 * Screen.widthRatio}px;
  max-width: ${1020 * Screen.widthRatio}px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

export default DetailEventTitle;
